module.exports = __webpack_public_path__ + "images/emoji/poodle.afbdc734a674914aee2e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/poodle.png
// module id = yO4M
// module chunks = 24